import Service from './Service';

export default class State extends Service {

  list({ filter }) {
    return this.axiosInstance.get(`/states${filter ? '?filter_uf=' + filter : ''}`);
  }

}
